import * as actions from "./actionsType";

const initialData = {
  loaderPaises: false,
  paises: null,
  paisesFalla: null,
  saveLoaderPaises: false,
  paisesFormError:null
};

export default function PaisesReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_PAISES:
      return { ...state, loaderPaises: action.payload };

    case actions.GET_PAISES:
      return { ...state, paises: action.payload };

    case actions.PAISES_FALLA:
      return { ...state, paisesFalla: action.payload };

    case actions.SAVE_LOADER_PAISES:
      return { ...state, saveLoaderPaises: action.payload };

    case actions.FORM_PAISES_FAIL:
      return { ...state, paisesFormError: action.payload };
      
    default:
      return state;
  }
}
